const VIEW_PARAM = 'view';

export function readViewIdFromLocation(search = typeof window !== 'undefined' ? window.location.search : '') {
  try {
    const id = new URLSearchParams(search).get(VIEW_PARAM) || '';
    return String(id).trim();
  } catch {
    return '';
  }
}

export function viewShareUrl(viewId, href = typeof window !== 'undefined' ? window.location.href : '') {
  const url = new URL(href, typeof window !== 'undefined' ? window.location.origin : 'http://local/');
  const id = String(viewId || '').trim();
  if (id) url.searchParams.set(VIEW_PARAM, id);
  else url.searchParams.delete(VIEW_PARAM);
  return url.toString();
}

export async function copyViewLink(viewId) {
  const href = viewShareUrl(viewId);
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(href);
    return href;
  }
  const ta = document.createElement('textarea');
  ta.value = href;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
  return href;
}
